module.exports = __webpack_public_path__ + "static/img/55862_0_basnie-rysunki konturowe il2_original2_out.cb387809.png";